import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {
	EnvConfig,
	EnvName,
	AppConfig,
	EnvHostVariables,
	DebugLevel,
	Auth0Config,
} from "./models/env-config.model";
import { environment } from "environments/environment";
import { AuthClientConfig } from "@auth0/auth0-angular";
import { LocalStorageService } from "@dodo/local-storage";
import { Auth0User } from "app/_core/services/models/auth0-user.model";
import { LocalStorageKeys } from "./local-storage-state-restor.service";

@Injectable({
	providedIn: "root",
})
export class EnvConfigProvider {
	private envConfig: EnvConfig | any;
	private envName: EnvName;
	authClientConfig;

	constructor(
		private http: HttpClient,
		authClientConfig: AuthClientConfig,
		private __localStore: LocalStorageService
	) {
		this.authClientConfig = authClientConfig;
	}

	public loadConfig(): void {
		const config = environment;
		const name = environment?.envConfigName;
		this.envConfig = config;
		this.envName = <EnvName>name;

		const auth0Config = this.auth0Config;
		this.authClientConfig.set({
			clientId: auth0Config.clientId,
			domain: auth0Config.domain,
			audience: auth0Config.audience,
			responseType: "code",
			redirect_uri: `${window.location.origin}${auth0Config.callbackUrl}`,
			scope: "openid email profile read:current_user read:app_metadata",
			useCookiesForTransactions: true,
			httpInterceptor: {
				allowedList: [
					{
						uriMatcher: (uri) => {
							if (
								uri.toLowerCase().indexOf("leadmgmt/lead") > -1
							) {
								const dealer = <Auth0User>(
									this.__localStore.getFromLocalStorage(
										LocalStorageKeys.dealer
									)
								);
								const kiosk = <Auth0User>(
									this.__localStore.getFromLocalStorage(
										LocalStorageKeys.kiosk
									)
								);
								return dealer || kiosk ? true : false;
							} else {
								return false;
							}
						},
					},
				],
			},
		});
	}

	public get config(): AppConfig {
		let finalConfig: AppConfig = null;

		if (this.envName && this.envConfig) {
			finalConfig = <AppConfig>{};

			const envSubConfig = <EnvHostVariables>(
				this.envConfig[this.envName.env]
			);

			finalConfig = {
				...finalConfig,
				envName: this.envName?.env,
				brand: this.envConfig?.brand,
				orgType: this.envConfig?.orgType,
				source: this.envConfig?.source,
				appName: this.envConfig?.appName,
				resellerIdParamName: this.envConfig?.resellerIdParamName,
				promoDiscountCodeParamName: this.envConfig
					?.promoDiscountCodeParamName,
				promoDiscountCodeParamNameMobile: this.envConfig
					?.promoDiscountCodeParamNameMobile,
				lookupDataLocation: this.envConfig?.lookupDataLocation,
				features: this.envConfig?.features,
				apiHost: envSubConfig?.apiHost,
				drupalHost: envSubConfig?.durpalApiHost,
				navLinkHost: envSubConfig?.navLinkHost,
				tealiumConfig: envSubConfig?.tealiumConfig,
				tealiumUtagJsEnv: envSubConfig?.tealiumUtagJsEnv,
				enableBundling: envSubConfig?.enableBundling,
				allowTestPage: envSubConfig?.allowTestPage,
				authOption: envSubConfig?.authOption,
				auth0Config: envSubConfig?.auth0Config,
				debugLevel: DebugLevel[this.envName.env],
				recaptchaSiteKey: envSubConfig?.recaptchaSiteKey,
				callbackUrl: envSubConfig?.callbackUrl,
				hfcCallbackUrl: envSubConfig?.hfcCallbackUrl,
				loggingApiHost: this.envConfig?.loggingApiHost,
				loggingApiKey: this.envConfig?.loggingApiKey,
				rqstCallbackUrl: envSubConfig?.rqstCallbackUrl,
			};
		}

		return finalConfig;
	}

	public get brand(): string {
		return this.envConfig.brand.toString();
	}

	public get orgType(): string {
		return this.envConfig.orgType.toString();
	}

	public get source(): string {
		return this.envConfig.source.toString();
	}

	public get debugLevel(): DebugLevel {
		return this.config.debugLevel;
	}

	public callBackUrl(): string {
		return this.config.callbackUrl;
	}

	public hfcCallBackUrl(): string {
		return this.config.hfcCallbackUrl;
	}

	public rqstCallbackUrl(): string {
		return this.config.rqstCallbackUrl;
	}

	public featureStatus(featureName: string): boolean {
		return this.config.features[featureName]
			? this.config.features[featureName]
			: false;
	}

	public get auth0Config(): Auth0Config {
		return this.config.auth0Config;
	}
}
